import { render, staticRenderFns } from "./IconProofreadPendingSmall.vue?vue&type=template&id=68796b54&"
import script from "./IconProofreadPendingSmall.vue?vue&type=script&lang=js&"
export * from "./IconProofreadPendingSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68796b54')) {
      api.createRecord('68796b54', component.options)
    } else {
      api.reload('68796b54', component.options)
    }
    module.hot.accept("./IconProofreadPendingSmall.vue?vue&type=template&id=68796b54&", function () {
      api.rerender('68796b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProofreadPendingSmall.vue"
export default component.exports